import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useRFQ } from '../../contexts/RFQContext';
import { BomProposalCard } from '../../components/robbie';
import { useBomProposal } from '../../hooks/useBomProposal';
import { BomEditProposal } from '../../types/bomProposal';
import { CurrentBomLine } from '../../utils/bomProposal';

/**
 * A proposal card wired to the RFQ in the store: the BOM it is judged
 * against is the one the RFQ shows now (`analysisData`), and a good apply
 * re-reads the RFQ silently so the sheet and the step behind it show the new
 * values.
 */
interface BomSource {
  rfqId?: string;
  analysisData?: { bomId?: string; components?: CurrentBomLine[] } | null;
  extractedData?: { bomId?: string; components?: CurrentBomLine[] } | null;
}

export interface WizardBomProposalProps {
  /** The assistant message the proposal belongs to, plus the action's position in it. */
  storageKey: string;
  proposal: BomEditProposal;
  canApply: boolean;
}

export const WizardBomProposal: React.FC<WizardBomProposalProps> = ({ storageKey, proposal, canApply }) => {
  const rfqData = useSelector((state: RootState) => state.rfq.rfqData as unknown as BomSource | null);
  const { fetchRFQ } = useRFQ();
  const analysis = rfqData?.analysisData || rfqData?.extractedData;
  const rfqId = rfqData?.rfqId;

  const state = useBomProposal({
    storageKey,
    proposal,
    currentBomId: analysis?.bomId ?? null,
    currentLines: analysis?.components ?? null,
    onApplied: rfqId ? () => fetchRFQ(rfqId, true, true) : undefined,
  });

  return (
    <BomProposalCard
      proposal={proposal}
      outcome={state.outcome}
      assessment={state.assessment}
      isTicked={state.isTicked}
      selectedChanges={state.selectedChanges}
      applying={state.applying}
      error={state.error}
      canApply={canApply}
      onToggle={state.toggle}
      onApply={state.apply}
      onDismiss={state.dismiss}
    />
  );
};

export default WizardBomProposal;
